import React from "react";

const MoreIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="16"
      viewBox="0 0 5 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.62988 4C3.72988 4 4.62988 3.1 4.62988 2C4.62988 0.9 3.72988 0 2.62988 0C1.52988 0 0.629883 0.9 0.629883 2C0.629883 3.1 1.52988 4 2.62988 4ZM2.62988 6C1.52988 6 0.629883 6.9 0.629883 8C0.629883 9.1 1.52988 10 2.62988 10C3.72988 10 4.62988 9.1 4.62988 8C4.62988 6.9 3.72988 6 2.62988 6ZM0.629883 14C0.629883 12.9 1.52988 12 2.62988 12C3.72988 12 4.62988 12.9 4.62988 14C4.62988 15.1 3.72988 16 2.62988 16C1.52988 16 0.629883 15.1 0.629883 14Z"
        fill="#DADADA"
      />
    </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="5"
    //   height="16"
    //   viewBox="0 0 5 16"
    //   fill="none"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M2.62976 4C3.72976 4 4.62976 3.1 4.62976 2C4.62976 0.9 3.72976 0 2.62976 0C1.52976 0 0.629761 0.9 0.629761 2C0.629761 3.1 1.52976 4 2.62976 4ZM2.62976 6C1.52976 6 0.629761 6.9 0.629761 8C0.629761 9.1 1.52976 10 2.62976 10C3.72976 10 4.62976 9.1 4.62976 8C4.62976 6.9 3.72976 6 2.62976 6ZM0.629761 14C0.629761 12.9 1.52976 12 2.62976 12C3.72976 12 4.62976 12.9 4.62976 14C4.62976 15.1 3.72976 16 2.62976 16C1.52976 16 0.629761 15.1 0.629761 14Z"
    //     fill="#DADADA"
    //   />
    // </svg>
  );
};

export default MoreIcon;
